import { getScanOrderCartons } from "@/apis/tms/order";
import { useQuery } from "@tanstack/react-query";

export interface ScanOrderCartonsRef {
  refresh: () => void;
}

export function useScanOrderCartons(orderId: string) {
  return useQuery({
    queryKey: [`order-${orderId}-cartons`],
    queryFn: () => getScanOrderCartons(orderId),
    placeholderData: (previousData) => previousData,
  });
}
